import { render, staticRenderFns } from "./BillModal.vue?vue&type=template&id=d8126ae2&scoped=true"
import script from "./BillModal.vue?vue&type=script&lang=js"
export * from "./BillModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8126ae2",
  null
  
)

export default component.exports